// extracted by mini-css-extract-plugin
export default {"card":"aZ-z","carouselContainer":"bZ-z","carouselContent":"cZ-z"};